import React from 'react';

import './EntryTitle.scoped.scss';

// Reusable label/title, wraps component and adds label on top of it
// Example:

// <EntryTitle title="My first title"> // tile is the only prop for this component, assigns title to it
// {
//   <TextField disabled value={""} onChange={() => {}} />
// }
// </EntryTitle>

interface Props {
  children?: React.ReactNode;
  title: string;
}

const EntryTitle: React.FC<Props> = ({ title, children }) => {
  return (
    <div className="entry-title">
      <div className="title">{title}</div>
      {children}
    </div>
  );
};

export default EntryTitle;
